
import {of as observableOf, timer as observableTimer,  Observable ,  Subscription, timer } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from './session.service';
import { SETTINGS } from '../../app.constants';
import { ModalService } from '../modals/modal.service';
import { Router } from '@angular/router';
import { RedirectService } from './redirect.service';
import { Url } from '../models/url/url.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map, retry } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

declare var $: any;

@Injectable()
export class TokenService {

    public jwtHelper: JwtHelperService = new JwtHelperService();
    private _activeTimer: Subscription;

    constructor(private session: SessionService,
                private translate: TranslateService,
                private modalService: ModalService,
                private http: HttpClient,
                private router: Router,
                private redirectService: RedirectService) { }

    public init() {

        let token = localStorage.getItem(SETTINGS.TOKEN_NAME);
        if (token) {
            if (this.jwtHelper.isTokenExpired(token)) {
                // if the token is already expired it must be an old token
                // from a previous session. Let's remove it, we will let the
                // user stay since they should be in view olnly mode as all users
                // who are scheduling will come in with a fresh token.
                // At this point in the app loading process we cannot tell if there
                // is a redirect url or even if they are in view only mode so we
                // are just going to make an assumption based on the intended behavior
                // of TTP external.
                localStorage.removeItem(SETTINGS.TOKEN_NAME);
            } else {
                this.startTimeoutWarningTimer();
            }
        }
    }

    public refreshAndUpdateToken(): Observable<boolean> {
        let refToken = localStorage.getItem(SETTINGS.TOKEN_NAME);
        if (refToken) {
            let tokenEndpoint = environment.uriCSEndpoint + 'credential/' + environment.apiVersion + 'refresh?token=' + refToken;
            return this.http.get(tokenEndpoint).pipe(
                retry(2))
                .pipe(
                    map((data:any) => {
                        if (data && data.hasOwnProperty('id_token')) {
                            localStorage.setItem(SETTINGS.TOKEN_NAME, data['id_token']);
                            return true;
                        }  else {
                            return false;
                        }
                    }),
                    catchError(() => { return observableOf(false);})
                );
        } else {
            return observableOf(false);
        }
    }

    private startTimeoutWarningTimer() {
        const token = localStorage.getItem(SETTINGS.TOKEN_NAME);
        const tokenExpireDate = this.jwtHelper.getTokenExpirationDate(token);
        const now = new Date().getTime();
        const timeToExpire = (tokenExpireDate.getTime() - now) - 120000;
        const activeTimer = timer(timeToExpire);
        this._activeTimer = activeTimer.subscribe(x => {
            // start a countdown from 60 seconds
            const countDownDate = new Date();
            countDownDate.setSeconds(countDownDate.getSeconds() + 60);
            let serviceRef = this;
            console.debug('Countdown Date:' + countDownDate.getTime());
            const y = setInterval(() => {
                const now2 = new Date().getTime();
                const distance = countDownDate.getTime() - now2;
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);
                const modal = document.getElementById('confirmModal');
                const body = modal.getElementsByClassName('modal-body')[0];
                const pTag = body.getElementsByTagName('p')[0];
                pTag.innerHTML = serviceRef.getSessionTimeoutMsg(seconds);
                if (distance <= 0) {
                    clearInterval(y);
                    $('#confirmModal').modal('hide');
                    serviceRef.modalService.notify('SESSION.EXPIRED', 'Session', 'MODAL.BUTTON_OK').then(() => {
                        if (serviceRef.session.returnUrl) {
                            let url:Url = serviceRef.redirectService.getReturnUrl(RedirectService.SESSION);
                            window.location.href = url.toString();
                        } else {
                            serviceRef.router.navigate(['/']);
                        }
                    });
                }
            }, 1000, serviceRef);

            this.modalService.confirm(this.getSessionTimeoutMsg(),
                    'Warning', 'GENERAL_REUSABLE.NO_BUTTON', 'GENERAL_REUSABLE.YES_BUTTON').then(confirmed => {
                if (confirmed) {
                    // refresh the token
                    clearInterval(y);
                    this.refreshAndUpdateToken().subscribe(refreshed => {
                        if (refreshed) {
                            this.startTimeoutWarningTimer();
                        } else {
                            // something went wrong we need to redirect the user back
                            if (this.session.returnUrl) {
                                let url: Url = this.redirectService.getReturnUrl(RedirectService.SESSION);
                                window.location.href = url.toString();
                            } else {
                                this.router.navigate(['/']);
                            }
                        }
                    });
                } else {
                    if (this.session.returnUrl) {
                        let url: Url = this.redirectService.getReturnUrl(RedirectService.SESSION);
                        window.location.href = url.toString();
                    } else {
                        this.router.navigate(['/']);
                    }
                }
            });
        });
    }

    private getSessionTimeoutMsg(seconds?: number): string {
        if(seconds) {
            switch(this.translate.currentLang) {
                case 'fr':
                    return 'Votre session est sur le point d\'expirer. (' + seconds + ' secondes restantes) Avez-vous besoin de plus de temps?';
                case 'es':
                    return 'Su sesión está a punto de caducar. (' + seconds + ' segundos restantes) ¿Necesita más tiempo?';
                default:
                    return 'Your session is about to expire. (' + seconds + ' seconds remaining) Do you need more time?';
            }
        } else {
            switch(this.translate.currentLang) {
                case 'fr':
                    return 'Votre session est sur le point d\'expirer. Avez-vous besoin de plus de temps?';
                case 'es':
                    return 'Su sesión está a punto de caducar. ¿Necesita más tiempo?';
                default:
                    return 'Your session is about to expire. Do you need more time?';
            }
        }
    }
}
